import { createFileRoute, redirect } from '@tanstack/react-router';

import { adminUserOptions } from '@/entities/admin-user';
import { getSafeReturnPath, SignInPage, signInSearchSchema } from '@/pages/sign-in';
import { isAuthError } from '@/shared/api/http-client';

export const Route = createFileRoute('/sign-in')({
    validateSearch: signInSearchSchema,
    beforeLoad: async ({ context: { queryClient }, search }) => {
        try {
            // Zero staleness forces a real /auth/me revalidation on every navigation —
            // ensureQueryData would accept a stale cached session up to 5 minutes old.
            await queryClient.fetchQuery({ ...adminUserOptions(), staleTime: 0 });
        } catch (error) {
            if (!isAuthError(error)) throw error;

            return;
        }
        throw redirect({ href: getSafeReturnPath(search.returnUrl) });
    },
    component: SignInRoute,
});

function SignInRoute() {
    const { returnUrl } = Route.useSearch();
    return <SignInPage returnUrl={returnUrl} />;
}
